import React from 'react'
import { Link} from "react-router-dom";
import sources from '../../data/data'

import './P.css'

function P() {

  return (
<>
    <div className="container">
        <div className="p">
            <div className="box-wrapper">

                {
                    Object.entries(sources).map(([key, value]) => (
                        <div key={key} className="box">
                            <h1>{value.category}</h1>

                            <div className="items-list">
                                <ul>
                                    {value.items.map((item) =>(
                                        <li key={item.slug}>
                                            <Link key={item.slug} to={`/${item.slug}`}>
                                                <img className='p-img' src={`/images/${item.path}`} alt={value.category} loading='lazy' />
                                            </Link>
                                        </li>
                                    ))
                                        
                                    }
                                </ul>
                            </div>
                        </div>
                    ))
                }
                


            </div>
        </div>
    </div>
</>
  )
}

export default P